import React from 'react'
import classNames from 'classnames'

import style from './style.scss'

type Props = React.ButtonHTMLAttributes<HTMLButtonElement>

function Button({ className, type = 'button', ...props }: Props) {
  return (
    <button
      className={classNames(style.button, className)}
      type={type}
      {...props}
    />
  )
}

export default Button
